import { Component } from '@angular/core';

@Component({
  selector: 'app-create-import',
  templateUrl: './create-import.component.html',
  styleUrls: ['./create-import.component.css']
})

export class CreateImportComponent {
  imageurl:any;
  errorMessage1:any
fileContent: string | ArrayBuffer | null = null;

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (!input.files || input.files.length === 0) return;

    const file = input.files[0];

    const reader = new FileReader();
    reader.onload = () => {
      this.fileContent = reader.result;
      // If needed, parse the XSL file here
    };
    reader.readAsText(file);
  }
}
